import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const STAFF_API_BASE = `${BACKEND_URL}/api`;
export const STAFF_TOKEN_KEY = "rescigo_staff_token";
export const STAFF_USER_KEY = "rescigo_staff_user";
export const STAFF_DEVICE_KEY = "rescigo_staff_device";

function ensureDeviceId() {
  let id = localStorage.getItem(STAFF_DEVICE_KEY);
  if (!id) {
    id = "dev-" + Math.random().toString(36).slice(2, 10) + "-" + Date.now().toString(36);
    localStorage.setItem(STAFF_DEVICE_KEY, id);
  }
  return id;
}
ensureDeviceId();

export const staffApi = axios.create({
  baseURL: STAFF_API_BASE,
  timeout: 20000,
});

staffApi.interceptors.request.use((config) => {
  // Iter 156 — align with staffAuth.jsx which persists tokens in
  // localStorage (was sessionStorage until Iter 152). Fall back to
  // sessionStorage for very old tabs that haven't reloaded yet.
  const token = localStorage.getItem(STAFF_TOKEN_KEY)
                || sessionStorage.getItem(STAFF_TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

staffApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && window.location.pathname.startsWith("/staff-app") &&
        window.location.pathname !== "/staff-app/login") {
      localStorage.removeItem(STAFF_TOKEN_KEY);
      localStorage.removeItem(STAFF_USER_KEY);
      sessionStorage.removeItem(STAFF_TOKEN_KEY);
      sessionStorage.removeItem(STAFF_USER_KEY);
      window.location.href = "/staff-app/login";
    }
    return Promise.reject(err);
  },
);

export function getDeviceId() {
  return localStorage.getItem(STAFF_DEVICE_KEY) || ensureDeviceId();
}

export function formatStaffErr(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join("; ");
  return String(d);
}

export function getGps(opts = { enableHighAccuracy: true, timeout: 8000, maximumAge: 30000 }) {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) { reject(new Error("GPS not supported")); return; }
    navigator.geolocation.getCurrentPosition(
      (p) => resolve({ latitude: p.coords.latitude, longitude: p.coords.longitude,
                        accuracy: p.coords.accuracy }),
      (e) => reject(e),
      opts,
    );
  });
}
